import gql from 'graphql-tag';

import { executeGqlMutation, type GqlMutationOptions } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendContentValidation,
  BackendMutationValidateCopyTextArgs,
} from 'src/types/backend';

import { FRAGMENT_CONTENT_VALIDATION } from './schema';

const MUTATION = gql`
  mutation ValidateCopyText($projectId: ID!, $text: String!, $assetType: AssetTypeEnum) {
    validateCopyText(projectId: $projectId, text: $text, assetType: $assetType) {
      ...ContentValidation
    }
  }
  ${FRAGMENT_CONTENT_VALIDATION}
`;

type Variables = BackendMutationValidateCopyTextArgs;
type Result = BackendContentValidation;

export const validateCopyText = async (
  variables: Variables,
  options?: Pick<GqlMutationOptions, 'abortSignal'>
) => {
  const result = await executeGqlMutation({
    mutation: MUTATION,
    variables,
    options: {
      abortSignal: options?.abortSignal,
      traceAcRequests: true,
    },
  });
  return getSingleProp<Result>(result.data);
};
